/**
 * Rules about Aquarius defect rows, shared by the Maintenance tab, the daily
 * checks PDF and the Control Centre Maintenance card so they cannot drift.
 */

/**
 * Aquarius sends a stand-in row ("Outstanding defect 2 of 5") when it only
 * knows how many defects a vehicle has, not what they are. It is not a defect.
 */
export function isPlaceholderOutstandingDefectRow(d: { details?: string | null; portal_id?: string | null }): boolean {
  const id = String(d.portal_id || '').trim();
  if (id.startsWith('outstanding:')) return true;
  const text = String(d.details || '')
    .replace(/\s*\(Aquarius assets summary\)\s*/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  return /^Outstanding defect \d+ of \d+$/i.test(text);
}
